import { tokens } from '@hotjar/hotsauce';

export const RETAKER_MODAL_HEADER_HEIGHT = tokens.spacer.x6;

export const RETAKER_BUTTON_BOTTOM_POSITION = tokens.spacer.x1pt5;
